import type { ParkingSpotStatus } from '../../../api/condominiums';
import type { AvailabilityWindow, ParkingSpotOwner, SpotUsage } from '../../../api/my-parking-spots';

export function calculateDynamicStatus(
  _spot: ParkingSpotOwner,
  windows: AvailabilityWindow[],
  activeUsages: SpotUsage[],
): ParkingSpotStatus {
  if (activeUsages.length > 0) {
    const activeUsage = activeUsages[0]!;
    return activeUsage.type === 'BORROW' ? 'BORROWED' : 'RENTED';
  }

  const now = new Date();
  const activeWindow = windows.find((window) => {
    if (window.status !== 'OPEN') return false;
    const windowStart = new Date(window.startAt);
    const windowEnd = new Date(window.endAt);
    return now >= windowStart && now <= windowEnd;
  });

  if (activeWindow) return 'AVAILABLE';
  return 'OCCUPIED';
}
